import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { AlertTriangle, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";

export default function ResetClubData() {
  const { t } = useLanguage();
  const [confirm, setConfirm] = useState("");
  const [working, setWorking] = useState(false);

  const reset = async () => {
    setWorking(true);
    try {
      const { data } = await api.post("/admin/reset-club-data", { confirm });
      const n = Object.values(data.removed).reduce((a, b) => a + b, 0);
      toast.success(t("reset.done", { n }));
      setTimeout(() => window.location.reload(), 1200);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setWorking(false);
    }
  };

  return (
    <Card className="border-destructive/40 mt-6" data-testid="reset-club-card">
      <CardHeader className="pb-3"><CardTitle className="text-lg flex items-center gap-2 text-destructive"><AlertTriangle size={18} /> {t("reset.title")}</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">{t("reset.desc")}</p>
        <AlertDialog onOpenChange={() => setConfirm("")}>
          <AlertDialogTrigger asChild>
            <Button variant="outline" className="rounded-full border-destructive/50 text-destructive hover:bg-destructive/10 gap-2" data-testid="reset-club-btn"><Trash2 size={14} /> {t("reset.btn")}</Button>
          </AlertDialogTrigger>
          <AlertDialogContent data-testid="reset-club-dialog">
            <AlertDialogHeader>
              <AlertDialogTitle>{t("reset.confirm_title")}</AlertDialogTitle>
              <AlertDialogDescription>{t("reset.confirm_desc")}</AlertDialogDescription>
            </AlertDialogHeader>
            <Input value={confirm} onChange={e => setConfirm(e.target.value.toUpperCase())} placeholder="RESET" className="font-mono h-11 rounded-xl" data-testid="reset-club-input" />
            <AlertDialogFooter>
              <AlertDialogCancel className="rounded-full" data-testid="reset-club-cancel">{t("reset.cancel")}</AlertDialogCancel>
              <AlertDialogAction onClick={reset} disabled={confirm !== "RESET" || working} className="rounded-full bg-destructive hover:bg-destructive/90 text-white" data-testid="reset-club-confirm">
                {working ? t("reset.working") : t("reset.go")}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </CardContent>
    </Card>
  );
}
